export default {
  defaultLayer: "Evapotranspiration",

  head: [
    {
      name: "NHP Home",
      path: "/",
      active: true,
    },
    {
      name: "ET Home",
      path: "/webgis-et",
      active: true,
    },
    {
      name: "Objective",
      path: "/webgis-et/proj-obj",
    },
    {
      name:'Download Products',
      path:'/nhp-data-download'
    },
    {
      name:'Flux Dashboard',
      path:'/et-flux-dashboard'
    }
    // {
    //     name:"Technical Proposal",
    //     path:"/webgis-et/tech-prop"

    // },
    // {
    //     name:"Project Team",
    //     path:"/webgis-et/proj-team"

    // },
    // {
    //     name:"Financial Proposal",
    //     path:"/webgis-et/fin-prop"
    // }

    // {

    //     name:"menu 3",
    //     path:"/"
    // },
  ],

  breadCrumbs: [
    {
      name: "menu 1",
      path: "/",
    },
    {
      name: "menu 2",
      path: "/",
    },
    {
      name: "menu 3",
      path: "/",
    },
  ],

  mapSideBar: [
    { 
  
      id: 5,
      name: "et-Evapotranspiration",
      displayname: "Actual Evapotranspiration",
      //icon: "stroopwafel",
      ismap: true,
      default: true,
      // default: 'Evapotranspiration',
      active: true,
      children: [{
          id: 6,
          name: 'et-Evapotranspiration',
          displayname: 'Daily',
          icon: "stroopwafel",
          ismap: true,
          default: true,
        },{
          id: 7,
          name: "et-Evapotranspiration-Fortnightly750",
          displayname: "Fortnightly",
          icon: "stroopwafel",
          //default: true,
          ismap: true,
        },{
          id: 7,
          name: "et-Evapotranspiration-Monthly750",
          displayname: "Monthly",
          icon: "stroopwafel",
          //default: true,
          ismap: true,
        }
        
      ],
    },
    {
      id: 8,
      name: "PET Evapotranspiration",
      displayname: "Potential Evapotranspiration",
      //icon: "stroopwafel",
      ismap: true,
      // default: 'Evapotranspiration',
      active: false,
      children: [{
        id: 6,
        name: 'pet-Evapotranspiration',
        displayname: 'Daily',
        icon: "stroopwafel",
        ismap: true,
        default: true,
      },{
        id: 7,
        name: "pet-Evapotranspiration-Fortnightly750",
        displayname: "Fortnightly",
        icon: "stroopwafel",
        //default: false,
        ismap: true,
      },{
        id: 7,
        name: "pet-Evapotranspiration-Monthly750",
        displayname: "Monthly",
        icon: "stroopwafel",
        //default: false,
        ismap: true,
      }
    ],
    },
    {
      id: 9,
      name: "MAI Evapotranspiration",
      displayname: "Moisture Adequacy Index",
      //icon: "stroopwafel",
      ismap: true,
      // default: 'Evapotranspiration',
      active: false,
      children: [{
        id: 7,
        name: "mai-Evapotranspiration-Fortnightly750",
        displayname: "Fortnightly",
        icon: "stroopwafel",
       default:true,
        ismap: true,
      },{
        id: 7,
        name: "mai-Evapotranspiration-Monthly750",
        displayname: "Monthly",
        icon: "stroopwafel",
        //default: false,
        ismap: true,
      }
    ],
    },
    {
      id: 10,
      name: "ESI Evapotranspiration",
      displayname: "Evaporative Stress Index",
      //icon: "stroopwafel",
      ismap: true,
      // default: 'Evapotranspiration',
      active: false,
      children: [{
        id: 7,
        name: "esi-Evapotranspiration-Fortnightly750",
        displayname: "Fortnightly",
        icon: "stroopwafel",
        ismap: true,
        default:true,
      },{
        id: 7,
        name: "esi-Evapotranspiration-Monthly750",
        displayname: "Monthly",
        icon: "stroopwafel",
        //default: false,

        ismap: true,
      }
    ],
    }
    // {
    //   id: 6,
    //   name: "Evapotranspiration-Monthly",
    //   displayname: "Evapotranspiration-Monthly",
    //   icon: "stroopwafel",
    //   ismap: true,
    //   default: true,
    // },
    // {
    //   id: 7,
    //   name: "Evapotranspiration-Fortnightly",
    //   displayname: "Evapotranspiration-Fortnightly",
    //   icon: "stroopwafel",
    //   ismap: true,
    //   default: true,
    // },


    // {
    //   id: 6,
    //   name: "Evapotranspiration_WB",
    //   displayname: "Evapotranspiration (WB)",
    //   icon: "stroopwafel",
    //   ismap: true,
    //   // "default":true
    // },
    // {
    //     "id": 3,
    //     "name": 'Net Radiation',
    //     "icon":"stroopwafel",
    //     "ismap":true,

    // },
    // {
    //     "id": 4,
    //     "name": 'Soil Heat Flux',
    //     "icon":"stroopwafel",
    //     "ismap":true,

    // },

    // {
    //   "id": 2,
    //   "name": "Layers",
    //   "icon":"stroopwafel",
    //   "children": [
    //     {
    //       "id": 3,
    //       "name": 'Net Radiation',
    //       "icon":"stroopwafel",
    //       "ismap":true,
    //       "defaultLayer":"NHP_ISRO_DNR_20190105"
    //     },
    //     {
    //       "id": 4,
    //       "name": 'Soil Heat Flux',
    //       "icon":"stroopwafel",
    //       "ismap":true,
    //       "defaultLayer":"NHP_ISRO_DSHF_20190105"
    //     },
    //     {
    //       "id": 5,
    //       "name": 'Evapotranspiration',
    //       "icon":"stroopwafel",
    //       "ismap":true,
    //       "defaultLayer":"NHP_ISRO_Daily_Evapotranspiration20190105"
    //     },

    //   ]
    // },
    // {
    //   "id": 2,
    //   "name": "Layers",
    //   "icon":"stroopwafel",
    //   "children": [
    //     {
    //       "id": 3,
    //       "name": 'Net Radiation',
    //       "icon":"stroopwafel"
    //     },
    //     {
    //       "id": 4,
    //       "name": 'Soil Heat Flux',
    //       "icon":"stroopwafel"
    //     },

    //   ]
    // },

    // {
    //   "id": 9,
    //   "name": "menu3",
    //   "icon":"stroopwafel",
    //   "children": [
    //     {
    //       "id": 10,
    //       "name": "menu3 child1",
    //       "icon":"stroopwafel",
    //       "children": [
    //             {
    //               "id": 163,
    //               "name": "menu3 child1 child1",
    //               "icon":"stroopwafel"
    //             },
    //             {
    //               "id": 166,
    //               "name": "menu3 child1 child2",
    //               "icon":"stroopwafel"
    //             }
    //           ]
    //     },
    //     {
    //       "id": 11,
    //       "name": "menu3 child2",
    //       "icon":"stroopwafel",
    //       "children": [
    //             {
    //               "id": 165,
    //               "name": "menu3 child2 child3",
    //               "icon":"stroopwafel"
    //             },
    //             {
    //               "id": 164,
    //               "name": "menu3 child2 child3",
    //               "icon":"stroopwafel",
    //               "children":[
    //                 {
    //                   "id": 165,
    //                   "name": "menu3 child2 child3 child1",
    //                   "icon":"stroopwafel"
    //                 },
    //                 {
    //                   "id": 167,
    //                   "name": "menu3 child2 child3 child2",
    //                   "icon":"stroopwafel"
    //                 }
    //               ]
    //             }
    //         ]
    //     }
    //   ]

    // }
  ],
};
